var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c(
      "a",
      {
        staticClass:
          "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out",
        attrs: { href: "#" }
      },
      [
        _c("div", { staticClass: "px-4 py-4 sm:px-6" }, [
          _c("div", { staticClass: "flex items-center justify-between" }, [
            _c(
              "div",
              {
                staticClass:
                  "text-sm leading-5 font-medium text-indigo-600 truncate"
              },
              [_vm._v(" " + _vm._s(_vm.template.name) + " ")]
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass:
                    "mx-2 inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 transition ease-in-out duration-150",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("edit", _vm.template)
                    }
                  }
                },
                [_vm._v(" Edit ")]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "mx-2 inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-50 focus:outline-none focus:border-red-300 focus:shadow-outline-red active:bg-red-200 transition ease-in-out duration-150",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("delete", _vm.template)
                    }
                  }
                },
                [_vm._v(" Delete ")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }